/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![LinkExternalMediumIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAsElEQVR4nO2UQQrCMBBFq3eo6I0GIZlkMWRA75K7KS7dWNHjVEI3KtbO2BG66Idsws97mUVSVXMmGxf45AO3qoXpKBaUsloQuDWdEohqF9LlLwIgqj1y04HT1VQAzzfHdI9xtzETwAd42TcRQA/cRABf4KMFMAAfJQAB/GfBO3xLtO7rqgUauFqghasELy8UuYlxv5L+XS7wYai38MhnLVycnPPSId+KpEwiPzlnynkA03jIxDaXqqAAAAAASUVORK5CYII=)
 */
export const LinkExternalMediumIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M7 4a1 1 0 0 0 0 2h9.59L4.29 18.3a1 1 0 1 0 1.42 1.4L18 7.42V17a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1H7Z"
        className={colorClass}
      />
    </svg>
  );
};
